/*
  WebGL Logo
  by khronosgroup (https://sketchfab.com/khronosgroup)
  via  https://sketchfab.com/3d-models/webgl-logo-f2301891d18a4a75aee621b190501172

  License: CC-BY-ND-4.0 (http://creativecommons.org/licenses/by-nd/4.0/)
  Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import { type JSX } from 'react'
import type { Mesh, MeshPhysicalMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      defaultMaterial: Mesh
    }
    materials: {
      WebGL: MeshPhysicalMaterial
    }
  }

export function WebGLLogo(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/webgl-logo.glb') as GLTFResult

  return (
    <group {...props} dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.defaultMaterial.geometry}
          material={materials.WebGL}
          rotation={[Math.PI / 2, 0, 0]}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/webgl-logo.glb')
